import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { OptimizationDao } from '@app/dao/optimization/optimization.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { EaProfilEmprunteurBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'ea-profil-emprunteur',
    templateUrl: './ea-profil-emprunteur.component.html',
    styleUrls: ['./ea-profil-emprunteur.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaProfilEmprunteurComponent),
        },
    ],
    standalone: false
})
export class EaProfilEmprunteurComponent
  extends EaProfilEmprunteurBuilder
  implements OnInit
{
  doneSubject: Subject<void> = new Subject<void>();
  tabChanged: BehaviorSubject<any> = new BehaviorSubject(null);
  changeTab: BehaviorSubject<any> = new BehaviorSubject(null);
  owners: any[];
  deplacementKilometriqueOptions: any[];
  travailEnHauteurOptions: any[];
  travailARisqueOptions: any[];

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private optimizationDao: OptimizationDao,
  ) {
    super(formConstructor);
    combineLatest([
      this.userDao.getOwners(),
      this.optimizationDao.getProfilEmprunteurReferences(),
    ]).subscribe(([owners, references]) => {
      this.owners = owners;
      this.deplacementKilometriqueOptions =
        references?.deplacementKilometrique || [];
      this.travailEnHauteurOptions = references?.travailEnHauteur || [];
      this.travailARisqueOptions = references?.travailARisque || [];
    });
  }

  ngOnInit() {}

  onSubmit() {
    const { optimizationId, accountId, profilEmprunteurs } = this.extract();
    this.prFormService.loading();
    this.optimizationDao
      .updateOptimizationInsuranceRate(
        accountId,
        optimizationId,
        profilEmprunteurs,
      )
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          if (success) this.callback(success);
          this.notificationService.success('La sauvegarde a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La sauvegarde a échoué');
        },
      );
  }

  nextTab() {
    this.changeTab.next('NEXT');
  }

  getUserName(ownerId: number) {
    const owner = this.owners.find(({ id }) => id === ownerId);
    return owner ? owner.label : '';
  }

  onTabChange(isLastTab: boolean) {
    this.tabChanged.next(isLastTab);
  }
}
